import { SecurityDataAccordionProps } from "./types";
import { AccordionContainer } from "@repo/core/components/layout/ProposalAccordion/components/AccordionContainer";
import { InfoSection } from "@repo/core/components/layout/ProposalAccordion/components/InfoSection";

export const SecurityDataAccordion = ({
  cpf,
  name,
  phone,
  ...rest
}: SecurityDataAccordionProps) => {
  return (
    <AccordionContainer {...rest}>
      <InfoSection title="CPF" value={cpf} />
      <InfoSection title="Cliente" value={name} />
      <InfoSection title="Celular" value={phone} />
    </AccordionContainer>
  );
};
